import type { en } from './translations/en';

export const SUPPORTED_LANGUAGES = ['en', 'de', 'es', 'fr', 'pt', 'it'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  it: 'Italiano',
};

type NestedKeyOf<T> = T extends object
  ? {
      [K in Extract<keyof T, string>]: T[K] extends object
        ? `${K}` | `${K}.${NestedKeyOf<T[K]>}`
        : `${K}`;
    }[Extract<keyof T, string>]
  : never;

export type TranslationKey = NestedKeyOf<typeof en>;

type DeepString<T> = T extends string
  ? string
  : T extends Record<string, unknown>
    ? { [K in keyof T]: DeepString<T[K]> }
    : T;

export type TranslationShape = DeepString<typeof en>;
